type Shop = {
  name: string
  url: string
  image: string
}

type Category = {
  category: string
  shops: Shop[]
}

export const data: Category[] = [
  {
    category: "Лучшие предложения",
    shops: [
      {
        name: "OZON.ru",
        url: "https://halvacard.ru/shops/internet/ozon-ru",
        image: "https://app.scb.ru/seoImages/partners/ozon-ru.jpeg",
      },
      {
        name: "Яндекс.Маркет",
        url: "https://halvacard.ru/shops/elektronika/yandex-market",
        image: "https://app.scb.ru/seoImages/partners/yandex-market.jpeg",
      },
      {
        name: "СИТИЛИНК",
        url: "https://halvacard.ru/shops/elektronika/citilink",
        image: "https://app.scb.ru/seoImages/partners/citilink.jpeg",
      },
      {
        name: "restore:",
        url: "https://halvacard.ru/shops/elektronika/re-store",
        image: "https://app.scb.ru/seoImages/partners/re-store.jpeg",
      },
      {
        name: "Пятёрочка",
        url: "https://halvacard.ru/shops/produktovye-magaziny/pyatyorochka",
        image: "https://app.scb.ru/seoImages/partners/pyatyorochka.png",
      },
      {
        name: "Hoff",
        url: "https://halvacard.ru/shops/mebel-i-interer/hoff",
        image: "https://app.scb.ru/seoImages/partners/hoff.png",
      },
      {
        name: "Все Инструменты.ру",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/vse-instrumenty-ru",
        image: "https://app.scb.ru/seoImages/partners/vse-instrumenty-ru.jpeg",
      },
      {
        name: "Lamoda.ru",
        url: "https://halvacard.ru/shops/odezhda/lamoda",
        image: "https://app.scb.ru/seoImages/partners/lamoda.jpeg",
      },
      {
        name: "Спортмастер",
        url: "https://halvacard.ru/shops/sport/sportmaster",
        image: "https://app.scb.ru/seoImages/partners/sportmaster.jpg",
      },
      {
        name: "Fix Price",
        url: "https://halvacard.ru/shops/produktovye-magaziny/fix-price",
        image: "https://app.scb.ru/seoImages/partners/fix-price.jpeg",
      },
    ],
  },
  {
    category: "Электроника",
    shops: [
      {
        name: "DNS",
        url: "https://halvacard.ru/shops/elektronika/dns",
        image: "https://app.scb.ru/seoImages/partners/dns.jpeg",
      },
      {
        name: "OZON.ru",
        url: "https://halvacard.ru/shops/internet/ozon-ru",
        image: "https://app.scb.ru/seoImages/partners/ozon-ru.jpeg",
      },
      {
        name: "Яндекс.Маркет",
        url: "https://halvacard.ru/shops/elektronika/yandex-market",
        image: "https://app.scb.ru/seoImages/partners/yandex-market.jpeg",
      },
      {
        name: "СИТИЛИНК",
        url: "https://halvacard.ru/shops/elektronika/citilink",
        image: "https://app.scb.ru/seoImages/partners/citilink.jpeg",
      },
      {
        name: "restore:",
        url: "https://halvacard.ru/shops/elektronika/re-store",
        image: "https://app.scb.ru/seoImages/partners/re-store.jpeg",
      },
      {
        name: "МТС",
        url: "https://halvacard.ru/shops/elektronika/mts",
        image: "https://app.scb.ru/seoImages/partners/mts.jpeg",
      },
      {
        name: "RBT",
        url: "https://halvacard.ru/shops/elektronika/rbthypermarket",
        image: "https://app.scb.ru/seoImages/partners/rbthypermarket.png",
      },
      {
        name: "МегаФон",
        url: "https://halvacard.ru/shops/elektronika/megafon",
        image: "https://app.scb.ru/seoImages/partners/megafon.png",
      },
      {
        name: "Haier",
        url: "https://halvacard.ru/shops/elektronika/haiertehnika",
        image: "https://app.scb.ru/seoImages/partners/haiertehnika.png",
      },
    ],
  },
  {
    category: "Продукты",
    shops: [
      {
        name: "Пятёрочка",
        url: "https://halvacard.ru/shops/produktovye-magaziny/pyatyorochka",
        image: "https://app.scb.ru/seoImages/partners/pyatyorochka.png",
      },
      {
        name: "Лента",
        url: "https://halvacard.ru/shops/produktovye-magaziny/lenta-magazin",
        image: "https://app.scb.ru/seoImages/partners/lenta-magazin.jpeg",
      },
      {
        name: "Fix Price",
        url: "https://halvacard.ru/shops/produktovye-magaziny/fix-price",
        image: "https://app.scb.ru/seoImages/partners/fix-price.jpeg",
      },
      {
        name: "Перекресток",
        url: "https://halvacard.ru/shops/produktovye-magaziny/perekrestok",
        image: "https://app.scb.ru/seoImages/partners/perekrestok.png",
      },
      {
        name: "METRO",
        url: "https://halvacard.ru/shops/produktovye-magaziny/metro-cash-and-carry",
        image: "https://app.scb.ru/seoImages/partners/metro-cash-and-carry.jpeg",
      },
      {
        name: "Монетка",
        url: "https://halvacard.ru/shops/produktovye-magaziny/monetkaru",
        image: "https://app.scb.ru/seoImages/partners/monetkaru.jpg",
      },
      {
        name: "Купер",
        url: "https://halvacard.ru/shops/produktovye-magaziny/kuper",
        image: "https://app.scb.ru/seoImages/partners/kuper.jpeg",
      },
      {
        name: "Пятёрочка доставка",
        url: "https://halvacard.ru/shops/produktovye-magaziny/pyatyorochka-dostavka",
        image: "https://app.scb.ru/seoImages/partners/pyatyorochka-dostavka.png",
      },
      {
        name: "TASTY COFFEE",
        url: "https://halvacard.ru/shops/produktovye-magaziny/tasty-coffee",
        image: "https://app.scb.ru/seoImages/partners/tasty-coffee.jpeg",
      },
      {
        name: "Винлаб",
        url: "https://halvacard.ru/shops/produktovye-magaziny/vinlab",
        image: "https://app.scb.ru/seoImages/partners/vinlab.png",
      },
      {
        name: "Ароматный Мир",
        url: "https://halvacard.ru/shops/produktovye-magaziny/aromatnmir",
        image: "https://app.scb.ru/seoImages/partners/aromatnmir.png",
      },
    ],
  },
  {
    category: "Онлайн-покупки",
    shops: [
      {
        name: "Купер",
        url: "https://halvacard.ru/shops/produktovye-magaziny/kuper",
        image: "https://app.scb.ru/seoImages/partners/kuper.jpeg",
      },
      {
        name: "Яндекс Еда",
        url: "https://halvacard.ru/shops/taxi-dostavka/yandeks-eda",
        image: "https://app.scb.ru/seoImages/partners/yandeks-eda.jpeg",
      },
      {
        name: "OZON.ru",
        url: "https://halvacard.ru/shops/internet/ozon-ru",
        image: "https://app.scb.ru/seoImages/partners/ozon-ru.jpeg",
      },
      {
        name: "Яндекс.Маркет",
        url: "https://halvacard.ru/shops/elektronika/yandex-market",
        image: "https://app.scb.ru/seoImages/partners/yandex-market.jpeg",
      },
      {
        name: "Пятёрочка доставка",
        url: "https://halvacard.ru/shops/produktovye-magaziny/pyatyorochka-dostavka",
        image: "https://app.scb.ru/seoImages/partners/pyatyorochka-dostavka.png",
      },
      {
        name: "Маркет Деливери",
        url: "https://halvacard.ru/shops/taxi-dostavka/market-deliveri",
        image: "https://app.scb.ru/seoImages/partners/market-deliveri.jpeg",
      },
      {
        name: "Lamoda.ru",
        url: "https://halvacard.ru/shops/odezhda/lamoda",
        image: "https://app.scb.ru/seoImages/partners/lamoda.jpeg",
      },
      {
        name: "Перекресток Впрок",
        url: "https://halvacard.ru/shops/produktovye-magaziny/perekrestokvprok",
        image: "https://app.scb.ru/seoImages/partners/perekrestokvprok.png",
      },
      {
        name: "Лента Доставка",
        url: "https://halvacard.ru/shops/taxi-dostavka/lenta-onlajn",
        image: "https://app.scb.ru/seoImages/partners/lenta-onlajn.jpeg",
      },
      {
        name: "Все Инструменты.ру",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/vse-instrumenty-ru",
        image: "https://app.scb.ru/seoImages/partners/vse-instrumenty-ru.jpeg",
      },
    ],
  },
  {
    category: "Путешествия",
    shops: [
      {
        name: "OneTwoTrip",
        url: "https://halvacard.ru/shops/turizm/onetwotrip",
        image: "https://app.scb.ru/seoImages/partners/OneTwoTrip.jpeg",
      },
      {
        name: "Яндекс Путешествия",
        url: "https://halvacard.ru/shops/turizm/yandeks-puteshestviya",
        image: "https://app.scb.ru/seoImages/partners/yandeks-puteshestviya.jpeg",
      },
      {
        name: "Ozon Travel",
        url: "https://halvacard.ru/shops/turizm/ozon-travel",
        image: "https://app.scb.ru/seoImages/partners/ozon-travel.jpeg",
      },
      {
        name: "Travelata.ru",
        url: "https://halvacard.ru/shops/turizm/travelataru",
        image: "https://app.scb.ru/seoImages/partners/travelataru.jpeg",
      },
      {
        name: "PEGAS Touristik",
        url: "https://halvacard.ru/shops/turizm/pegastouristik",
        image: "https://app.scb.ru/seoImages/partners/pegastouristik.jpg",
      },
      {
        name: "aviakassa",
        url: "https://halvacard.ru/shops/turizm/aviakassa",
        image: "https://app.scb.ru/seoImages/partners/aviakassa.jpeg",
      },
      {
        name: "Level.Travel",
        url: "https://halvacard.ru/shops/turizm/level-travel",
        image: "https://app.scb.ru/seoImages/partners/level-travel.jpeg",
      },
      {
        name: "FUN&SUN",
        url: "https://halvacard.ru/shops/turizm/funandsun",
        image: "https://app.scb.ru/seoImages/partners/funandsun.jpeg",
      },
      {
        name: "Суточно.ру",
        url: "https://halvacard.ru/shops/turizm/sutochno-ru",
        image: "https://app.scb.ru/seoImages/partners/sutochno-ru.jpeg",
      },
      {
        name: "Coraltravel",
        url: "https://halvacard.ru/shops/turizm/coraltravel-turizm",
        image: "https://app.scb.ru/seoImages/partners/coraltravel-turizm.jpeg",
      },
      {
        name: "Sunmar",
        url: "https://halvacard.ru/shops/turizm/sunmar-agent",
        image: "https://app.scb.ru/seoImages/partners/sunmar-agent.png",
      },
    ],
  },
  {
    category: "Мебель и товары для дома",
    shops: [
      {
        name: "Hoff",
        url: "https://halvacard.ru/shops/mebel-i-interer/hoff",
        image: "https://app.scb.ru/seoImages/partners/hoff.png",
      },
      {
        name: "Divan.ru",
        url: "https://halvacard.ru/shops/mebel-i-interer/divanru",
        image: "https://app.scb.ru/seoImages/partners/divanru.jpeg",
      },
      {
        name: "Галамарт",
        url: "https://halvacard.ru/shops/mebel-i-interer/galamart",
        image: "https://app.scb.ru/seoImages/partners/galamart.png",
      },
      {
        name: "Askona",
        url: "https://halvacard.ru/shops/mebel-i-interer/askona-salony",
        image: "https://app.scb.ru/seoImages/partners/askona-salony.jpeg",
      },
      {
        name: "FIX PRICE",
        url: "https://halvacard.ru/shops/mebel-i-interer/fixprice",
        image: "https://app.scb.ru/seoImages/partners/fix-price.jpeg",
      },
      {
        name: "Fissman",
        url: "https://halvacard.ru/shops/mebel-i-interer/fissman-magazin",
        image: "https://app.scb.ru/seoImages/partners/fissman-magazin.png",
      },
      {
        name: "ORMATEK",
        url: "https://halvacard.ru/shops/mebel-i-interer/ormatek",
        image: "https://app.scb.ru/seoImages/partners/ormatek.png",
      },
      {
        name: "ЦВЕТ ДИВАНОВ",
        url: "https://halvacard.ru/shops/mebel-i-interer/cvet-divanov",
        image: "https://app.scb.ru/seoImages/partners/cvet-divanov.png",
      },
      {
        name: "GIPFEL International",
        url: "https://halvacard.ru/shops/mebel-i-interer/gipfelinternational",
        image: "https://app.scb.ru/seoImages/partners/gipfelinternational.png",
      },
      {
        name: "MOON",
        url: "https://halvacard.ru/shops/mebel-i-interer/moon",
        image: "https://app.scb.ru/seoImages/partners/moon.jpeg",
      },
    ],
  },
  {
    category: "Товары для ремонта",
    shops: [
      {
        name: "Все Инструменты.ру",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/vse-instrumenty-ru",
        image: "https://app.scb.ru/seoImages/partners/vse-instrumenty-ru.jpeg",
      },
      {
        name: "Петрович",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/petrovich",
        image: "https://app.scb.ru/seoImages/partners/petrovich.png",
      },
      {
        name: "СТРОЙЛАНДИЯ",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/strojlandiya",
        image: "https://app.scb.ru/seoImages/partners/strojlandiya.jpeg",
      },
      {
        name: "OBI",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/obi",
        image: "https://app.scb.ru/seoImages/partners/obi.png",
      },
      {
        name: "Строительный двор",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/stroitelnyj-dvor-tovary-dlya-remonta",
        image: "https://app.scb.ru/seoImages/partners/stroitelnyj-dvor-tovary-dlya-remonta.png",
      },
      {
        name: "Теплодар",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/teplodarnovosibirsk",
        image: "https://app.scb.ru/seoImages/partners/teplodarnovosibirsk.png",
      },
      {
        name: "OZON.ru",
        url: "https://halvacard.ru/shops/internet/ozon-ru",
        image: "https://app.scb.ru/seoImages/partners/ozon-ru.jpeg",
      },
      {
        name: "АПлайн",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/aplajn",
        image: "https://app.scb.ru/seoImages/partners/aplajn.jpeg",
      },
      {
        name: "Гардиан",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/gardian",
        image: "https://app.scb.ru/seoImages/partners/gardian.png",
      },
      {
        name: "Яндекс.Маркет",
        url: "https://halvacard.ru/shops/elektronika/yandex-market",
        image: "https://app.scb.ru/seoImages/partners/yandex-market.jpeg",
      },
      {
        name: "220 Вольт",
        url: "https://halvacard.ru/shops/tovary-dlya-remonta/220-volt-magazin",
        image: "https://app.scb.ru/seoImages/partners/220-volt-magazin.png",
      },
    ],
  },
  {
    category: "Одежда и аксессуары",
    shops: [
      {
        name: "Lamoda.ru",
        url: "https://halvacard.ru/shops/odezhda/lamoda",
        image: "https://app.scb.ru/seoImages/partners/lamoda.jpeg",
      },
      {
        name: "СТОКМАНН",
        url: "https://halvacard.ru/shops/odezhda/stokmann",
        image: "https://app.scb.ru/seoImages/partners/stokmann.jpeg",
      },
      {
        name: "familia",
        url: "https://halvacard.ru/shops/odezhda/familia",
        image: "https://app.scb.ru/seoImages/partners/familia.jpeg",
      },
      {
        name: "Снежная Королева",
        url: "https://halvacard.ru/shops/odezhda/snezhnaya-koroleva",
        image: "https://app.scb.ru/seoImages/partners/snezhnaya-koroleva.jpeg",
      },
      {
        name: "MODIS",
        url: "https://halvacard.ru/shops/odezhda/modis-odezhda",
        image: "https://app.scb.ru/seoImages/partners/modis-odezhda.png",
      },
      {
        name: "O`STIN",
        url: "https://halvacard.ru/shops/odezhda/ostin",
        image: "https://app.scb.ru/seoImages/partners/ostin.png",
      },
      {
        name: "ТВОЕ",
        url: "https://halvacard.ru/shops/odezhda/tvoeru",
        image: "https://app.scb.ru/seoImages/partners/tvoeru.png",
      },
      {
        name: "Zarina",
        url: "https://halvacard.ru/shops/odezhda/zarinaru",
        image: "https://app.scb.ru/seoImages/partners/zarinaru.png",
      },
      {
        name: "Gloria Jeans",
        url: "https://halvacard.ru/shops/odezhda/gloriajeans",
        image: "https://app.scb.ru/seoImages/partners/gloriajeans.jpeg",
      },
      {
        name: "COLIN`S",
        url: "https://halvacard.ru/shops/odezhda/colin-s",
        image: "https://app.scb.ru/seoImages/partners/colin-s.png",
      },
      {
        name: "befree",
        url: "https://halvacard.ru/shops/odezhda/befree-odezhda",
        image: "https://app.scb.ru/seoImages/partners/befree-odezhda.jpeg",
      },
    ],
  },
  {
    category: "Авто",
    shops: [
      {
        name: "Колеса Даром",
        url: "https://halvacard.ru/shops/avto/kolesa-darom",
        image: "https://app.scb.ru/seoImages/partners/kolesa-darom.png",
      },
      {
        name: "ROSSKO",
        url: "https://halvacard.ru/shops/avto/rossko",
        image: "https://app.scb.ru/seoImages/partners/rossko.jpeg",
      },
      {
        name: "FIT Service",
        url: "https://halvacard.ru/shops/avto/fitservice",
        image: "https://app.scb.ru/seoImages/partners/fitservice.jpeg",
      },
      {
        name: "LADA",
        url: "https://halvacard.ru/shops/avto/ladaoficialnyjdiler",
        image: "https://app.scb.ru/seoImages/partners/ladaoficialnyjdiler.jpeg",
      },
      {
        name: "Автодор - Платные дороги",
        url: "https://halvacard.ru/shops/avto/avtodor-platnye-dorogi",
        image: "https://app.scb.ru/seoImages/partners/avtodor-platnye-dorogi.jpeg",
      },
      {
        name: "ЛУКОЙЛ",
        url: "https://halvacard.ru/shops/zapravki/lukoil",
        image: "https://app.scb.ru/seoImages/partners/lukoil.png",
      },
      {
        name: "TATNEFT",
        url: "https://halvacard.ru/shops/zapravki/tatneft-18671139",
        image: "https://app.scb.ru/seoImages/partners/tatneft.png",
      },
      {
        name: "колесо.ру",
        url: "https://halvacard.ru/shops/avto/kolesoru",
        image: "https://app.scb.ru/seoImages/partners/kolesoru.jpeg",
      },
      {
        name: "ШИНСЕРВИС",
        url: "https://halvacard.ru/shops/avto/shinservice",
        image: "https://app.scb.ru/seoImages/partners/shinservice.jpeg",
      },
      {
        name: "Teboil",
        url: "https://halvacard.ru/shops/zapravki/teboil",
        image: "https://app.scb.ru/seoImages/partners/teboil.jpeg",
      },
      {
        name: "Сеть АЗС Газпромнефть",
        url: "https://halvacard.ru/shops/zapravki/setazsgazpromneft",
        image: "https://app.scb.ru/seoImages/partners/setazsgazpromneft.jpg",
      },
    ],
  },
  {
    category: "Аптеки",
    shops: [
      {
        name: "ВИТА",
        url: "https://halvacard.ru/shops/apteki/vita",
        image: "https://app.scb.ru/seoImages/partners/vita.jpeg",
      },
      {
        name: "ПЛАНЕТА ЗДОРОВЬЯ",
        url: "https://halvacard.ru/shops/apteki/planeta-zdorovya",
        image: "https://app.scb.ru/seoImages/partners/planeta-zdorovya.jpeg",
      },
      {
        name: "Магнит Аптека",
        url: "https://halvacard.ru/shops/apteki/magnit-apteka",
        image: "https://app.scb.ru/seoImages/partners/magnit-apteka.jpeg",
      },
      {
        name: "ГОРЗДРАВ",
        url: "https://halvacard.ru/shops/apteki/gorzdrav",
        image: "https://app.scb.ru/seoImages/partners/gorzdrav.jpg",
      },
      {
        name: "Аптека Миницен",
        url: "https://halvacard.ru/shops/apteki/apteka-minicen",
        image: "https://app.scb.ru/seoImages/partners/apteka-minicen.jpeg",
      },
      {
        name: "ЕАПТЕКА",
        url: "https://halvacard.ru/shops/apteki/eapteka",
        image: "https://app.scb.ru/seoImages/partners/eapteka.jpeg",
      },
      {
        name: "Озерки",
        url: "https://halvacard.ru/shops/apteki/ozerki",
        image: "https://app.scb.ru/seoImages/partners/ozerki.png",
      },
      {
        name: "36,6",
        url: "https://halvacard.ru/shops/apteki/36-6",
        image: "https://app.scb.ru/seoImages/partners/36-6.png",
      },
      {
        name: "ФАРМАЦИЯ",
        url: "https://halvacard.ru/shops/apteki/farmaciya-apteki",
        image: "https://app.scb.ru/seoImages/partners/farmaciya-apteki.png",
      },
      {
        name: "Белая аптека",
        url: "https://halvacard.ru/shops/apteki/belaya-apteka",
        image: "https://app.scb.ru/seoImages/partners/belaya-apteka.png",
      },
      {
        name: "Доктор Столетов",
        url: "https://halvacard.ru/shops/apteki/doktorstoletov",
        image: "https://app.scb.ru/seoImages/partners/doktorstoletov.png",
      },
    ],
  },
  {
    category: "Обувь",
    shops: [
      {
        name: "KARI",
        url: "https://halvacard.ru/shops/obuv/kari",
        image: "https://app.scb.ru/seoImages/partners/kari.jpeg",
      },
      {
        name: "RENDEZ-VOUS",
        url: "https://halvacard.ru/shops/obuv/rendez-vous",
        image: "https://app.scb.ru/seoImages/partners/rendez-vous.png",
      },
      {
        name: "EKONIKA",
        url: "https://halvacard.ru/shops/obuv/ekonika",
        image: "https://app.scb.ru/seoImages/partners/ekonika.jpeg",
      },
      {
        name: "Юничел",
        url: "https://halvacard.ru/shops/obuv/yunichel",
        image: "https://app.scb.ru/seoImages/partners/yunichel.jpeg",
      },
      {
        name: "ecco",
        url: "https://halvacard.ru/shops/obuv/ecco1",
        image: "https://app.scb.ru/seoImages/partners/ecco1.png",
      },
      {
        name: "RALF RINGER",
        url: "https://halvacard.ru/shops/obuv/ralfringer",
        image: "https://app.scb.ru/seoImages/partners/ralfringer.jpg",
      },
      {
        name: "Street Beat",
        url: "https://halvacard.ru/shops/obuv/street-beat",
        image: "https://app.scb.ru/seoImages/partners/street-beat.png",
      },
      {
        name: "МОНРО",
        url: "https://halvacard.ru/shops/obuv/monro",
        image: "https://app.scb.ru/seoImages/partners/monro.png",
      },
      {
        name: "ZENDEN",
        url: "https://halvacard.ru/shops/obuv/zenden",
        image: "https://app.scb.ru/seoImages/partners/zenden.jpeg",
      },
      {
        name: "Respect",
        url: "https://halvacard.ru/shops/obuv/respectt",
        image: "https://app.scb.ru/seoImages/partners/respectt.png",
      },
      {
        name: "БашМаг",
        url: "https://halvacard.ru/shops/obuv/bashmag-obuv",
        image: "https://app.scb.ru/seoImages/partners/bashmag.png",
      },
    ],
  },
  {
    category: "Косметика и парфюмерия",
    shops: [
      {
        name: "РИВ ГОШ",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/riv-gosh",
        image: "https://app.scb.ru/seoImages/partners/riv-gosh.png",
      },
      {
        name: "Улыбка Радуги",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/ulybka-radugi",
        image: "https://app.scb.ru/seoImages/partners/ulybka-radugi.jpeg",
      },
      {
        name: "ИЛЬ ДЕ БОТЭ",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/il-de-bote",
        image: "https://app.scb.ru/seoImages/partners/il-de-bote.jpeg",
      },
      {
        name: "Новэкс",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/noveks",
        image: "https://app.scb.ru/seoImages/partners/noveks.png",
      },
      {
        name: "KIKO MILANO",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/kikomilano",
        image: "https://app.scb.ru/seoImages/partners/kikomilano.JPG",
      },
      {
        name: "Yves Rocher",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/yvesrocher",
        image: "https://app.scb.ru/seoImages/partners/yvesrocher.jpeg",
      },
      {
        name: "Л`Этуаль",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/letual-magazin",
        image: "https://app.scb.ru/seoImages/partners/letual-magazin.jpeg",
      },
      {
        name: "Natura Siberica",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/natura-siberica",
        image: "https://app.scb.ru/seoImages/partners/natura-siberica.jpeg",
      },
      {
        name: "Organic Shop",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/organic-shop",
        image: "https://app.scb.ru/seoImages/partners/organic-shop.jpeg",
      },
      {
        name: "Проф Косметика",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/profkosmetics",
        image: "https://app.scb.ru/seoImages/partners/profkosmetics.png",
      },
      {
        name: "LETIQUE",
        url: "https://halvacard.ru/shops/kosmetika-i-parfyumeriya/letique",
        image: "https://app.scb.ru/seoImages/partners/letique.png",
      },
    ],
  },
  {
    category: "Кафе и рестораны",
    shops: [
      {
        name: "ROSTIC`S",
        url: "https://halvacard.ru/shops/kafe-i-restorany/rostic-s",
        image: "https://app.scb.ru/seoImages/partners/rostic-s.jpeg",
      },
      {
        name: "Бургер Кинг",
        url: "https://halvacard.ru/shops/kafe-i-restorany/burgerking",
        image: "https://app.scb.ru/seoImages/partners/burgerking.png",
      },
      {
        name: "ДОДО ПИЦЦА",
        url: "https://halvacard.ru/shops/kafe-i-restorany/dodopizza",
        image: "https://app.scb.ru/seoImages/partners/dodopizza.png",
      },
      {
        name: "Ёбидоёби",
        url: "https://halvacard.ru/shops/kafe-i-restorany/yobidoyobi",
        image: "https://app.scb.ru/seoImages/partners/yobidoyobi.jpeg",
      },
      {
        name: "Суши Мастер",
        url: "https://halvacard.ru/shops/kafe-i-restorany/sushi-master",
        image: "https://app.scb.ru/seoImages/partners/sushi-master.jpeg",
      },
      {
        name: "Папа Джонс",
        url: "https://halvacard.ru/shops/kafe-i-restorany/papajohns",
        image: "https://app.scb.ru/seoImages/partners/papajohns.jpeg",
      },
      {
        name: "Теремок",
        url: "https://halvacard.ru/shops/kafe-i-restorany/teremok-restoran",
        image: "https://app.scb.ru/seoImages/partners/teremok-restoran.png",
      },
      {
        name: "Coffee Like",
        url: "https://halvacard.ru/shops/kafe-i-restorany/coffeelike",
        image: "https://app.scb.ru/seoImages/partners/coffeelike.jpeg",
      },
      {
        name: "Суши Даром",
        url: "https://halvacard.ru/shops/kafe-i-restorany/sushidarom",
        image: "https://app.scb.ru/seoImages/partners/sushidarom.png",
      },
      {
        name: "Zotman Pizza",
        url: "https://halvacard.ru/shops/kafe-i-restorany/zotman-pizza",
        image: "https://app.scb.ru/seoImages/partners/zotman-pizza.jpeg",
      },
      {
        name: "FOODBAND",
        url: "https://halvacard.ru/shops/kafe-i-restorany/foodband",
        image: "https://app.scb.ru/seoImages/partners/foodband.jpeg",
      },
    ],
  },
]
